import { useEffect, useState } from 'react';

export const useLegacyRedirect = () => {
  const [showLegacyModal, setShowLegacyModal] = useState(false);

  useEffect(() => {
    if (!showLegacyModal) return;

    const timeout = setTimeout(() => {
      const legacyUrl =
        process.env.ENVIRO === 'production' || process.env.ENVIRO === 'prod'
          ? 'https://app.topsteptrader.com/login'
          : 'https://staging.topsteptrader.com/login';
      window.location.href = legacyUrl;
    }, 5000);

    return () => clearTimeout(timeout);
  }, [showLegacyModal]);

  return {
    showLegacyModal,
    triggerLegacyRedirect: () => setShowLegacyModal(true),
  };
};
